module.exports = __webpack_public_path__ + "16b591e5de8e9f2b5e3fe346989040b5.png";